import React, { FunctionComponent } from "react";
import { getOrCreateRoot } from "banco/util/reactRoot";
import { API_STATUSES, API_UNAVAILABLE_MESSAGE } from "banco/constants";
import { Spinner } from "banco-components";
import { PageContainer } from "banco-website/Utils/PageContainer";

type HeaderProps = {
  title: string,
  requestState: API_STATUSES
};

export const GenericRequestStatusHeader = ({ title, requestState }: HeaderProps) => (
  <>
    <h2>{ title }</h2>
    { requestState !== API_STATUSES.SUCCESS && (
      <div style={ { marginTop: "1rem" } }>
        { requestState === API_STATUSES.LOADING && <Spinner /> }
        { requestState === API_STATUSES.ERROR && API_UNAVAILABLE_MESSAGE }
      </div>
    ) }
  </>
);
type ComponentLoaderProps = {
  component: FunctionComponent<any>,
  propsKey: string,
  hookDivId: string
}

export const componentLoader = ({ component, propsKey, hookDivId }:ComponentLoaderProps) => {
  const hook_div = document.getElementById(hookDivId);

  if (hook_div !== null) {
    const propsHolder = window.fb;

    getOrCreateRoot(hook_div).render(
      React.createElement(
        PageContainer,
        null,
        React.createElement(
          component,
          // @ts-expect-error The key used here will vary depending on the component.
          JSON.parse(window.atob(propsHolder[propsKey]))
        )
      )
    );
  }
};
